import { motion } from "framer-motion";
import { ArrowRight, Sparkle } from "@phosphor-icons/react";
import { IMAGES } from "../data";
import { useLang } from "../i18n/LanguageContext";

export default function Hero() {
  const { t } = useLang();
  const h = t.hero;
  return (
    <section id="top" data-testid="hero-section" className="relative min-h-[92vh] flex items-end overflow-hidden">
      <div className="absolute inset-0 grain">
        <img src={IMAGES.hero} alt="Eventservice" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#1e2a6e]/78" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A0D1F]/80 via-transparent to-[#1e2a6e]/40" />
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-5 sm:px-8 pb-16 sm:pb-24 pt-32">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: "easeOut" }}
          className="inline-flex items-center gap-2 rounded-full bg-white/10 border border-white/20 px-4 py-1.5 backdrop-blur-sm mb-7"
        >
          <Sparkle size={16} weight="fill" className="text-[#4a90d9]" />
          <span className="font-accent text-xs tracking-[0.2em] uppercase text-white/90 font-semibold">
            {h.badge}
          </span>
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 28 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.1, ease: "easeOut" }}
          className="font-heading text-white font-black tracking-tighter leading-[0.95] text-4xl sm:text-6xl lg:text-7xl max-w-4xl"
        >
          {h.titleLine1}
          <br />
          <span className="text-[#4a90d9]">{h.titleAccent}</span>
          {h.titleLine2}
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.25, ease: "easeOut" }}
          className="mt-7 text-base sm:text-xl text-white/85 max-w-2xl leading-relaxed"
        >
          {h.subtitle}
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4, ease: "easeOut" }}
          className="mt-10 flex flex-col sm:flex-row gap-4"
        >
          <a
            href="#kontakt"
            data-testid="hero-cta-primary"
            className="group inline-flex items-center justify-center gap-2 rounded-full bg-[#4a90d9] px-8 py-4 text-base font-semibold text-white hover:bg-white hover:text-[#1e2a6e] transition-colors duration-200"
          >
            {h.ctaPrimary}
            <ArrowRight size={20} weight="bold" className="group-hover:translate-x-1 transition-transform duration-200" />
          </a>
          <a
            href="#leistungen"
            data-testid="hero-cta-secondary"
            className="inline-flex items-center justify-center rounded-full border border-white/30 px-8 py-4 text-base font-semibold text-white hover:bg-white/10 transition-colors duration-200"
          >
            {h.ctaSecondary}
          </a>
        </motion.div>
      </div>
    </section>
  );
}
